module.exports = "<router-outlet><app-environment-ribbon></app-environment-ribbon></router-outlet>\n"